import React, { Fragment, useEffect, useState } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';
import CrmUser from '../../models/CrmUser';

const FormPartial = (props) => {
  const { crmUser } = props;
  const [usersTypesApi] = getApi('usersTypes');
  const [usersTypes, setUsersTypes] = useState([]);
  let crmUserObj = new CrmUser(crmUser);
  const [selectedUsersTypes, setSelectedUsersTypes] = useState([]);

  const fetchUsersTypes = async () => {
    try {
      const response = await usersTypesApi({ filters: { crm_users_types: true }}).unwrap();
      setUsersTypes(response.data.users_types);
    } catch(error) {

    }
  }

  useEffect(() => {
    fetchUsersTypes();
  }, [])

  useEffect(() => {
    crmUserObj.updateData(crmUser);
    setSelectedUsersTypes(crmUserObj.selectedUsersTypes(usersTypes))
  }, [crmUser])

  const validateValue = (field) => {
    crmUserObj.validate(field);
  }

  const changeValue = (field, value) => {
    crmUserObj[field] = value;
    validateValue(field);
    props.setCrmUser(crmUserObj.toStateJson());
  }

  const onSelect = (selectedList, selectedItem) => {
    crmUserObj.addRole(selectedItem);
    props.setCrmUser(crmUserObj.toStateJson());
    setSelectedUsersTypes(crmUserObj.selectedUsersTypes(usersTypes));
  }

  const onRemove = (selectedList, removedItem) => {
    crmUserObj.removeRole(removedItem);
    props.setCrmUser(crmUserObj.toStateJson());
    setSelectedUsersTypes(crmUserObj.selectedUsersTypes(usersTypes));
  }
  return <Fragment>
    <div className="mb-0 col-md-6">
      <label htmlFor="name" className="form-label mb-1">Enter Full Name</label>
      <input
        id="name"
        value={crmUser.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        aria-describedby="name_help"
        placeholder='Enter Name'
      />
      <div id="name_help" className="form-text text-danger mt-0">
        {crmUser.errors.name}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="email" className="form-label mb-1">Email address</label>
      <input
        id="email"
        defaultValue={crmUser.email}
        onChange={(e) => changeValue('email', e.target.value)}
        type="email"
        className="form-control form-control-sm font-size-12"
        aria-describedby="email_help"
        placeholder='Enter Email'
        disabled={crmUser.id !== null }
      />
      <div id="email_help" className="form-text text-danger mt-0">
        {crmUser.errors.email}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="mobile_number" className="form-label mb-1">Mobile Number</label>
      <input
        id="mobile_number"
        value={crmUser.mobile_number}
        onChange={(e) => changeValue('mobile_number', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        aria-describedby="mobile_number_help"
        placeholder='Enter Mobile Number'
      />
      <div id="mobile_number_help" className="form-text text-danger mt-0">
        {crmUser.errors.mobile_number}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="user_roles" className="form-label mb-1">Select Role</label>
      <Multiselect
        id="user_roles"
        options={usersTypes}
        selectedValues={selectedUsersTypes}
        onSelect={onSelect}
        onRemove={onRemove}
        displayValue="role_name" 
      />
      {/* <div id="user_roles_help" className="form-text text-danger mt-0">
        {crmUser.errors.user_roles}
      </div> */}
    </div>
  </Fragment>
}

export default FormPartial;
